import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import ModeInputHelperText from './ModeInputHelperText.react';

// Returns a range of numeric values from low to high incrementing by step
// Handles up to 1 digit of floating point math
const range = (low, high, step) => {
  const list = [];
  for (let i = (low * 10); i <= (high * 10); i += (step * 10)) {
    list.push(i / 10);
  }
  return list;
};

const padding = { marginBottom: '10px', marginTop: '10px' };

export default class ImpactFactor extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.updateImpactFactor(e.target.value);
  }

  render() {
    const rangeVals = { step: 0.1, min: 0.1, max: 2.0 };

    return (
      <Row style={padding}>
        <Col md={8}>
          <input
            type='range'
            onChange={this.onChange}
            value={this.props.mode.impactFactor}
            step={rangeVals.step}
            min={rangeVals.min}
            max={rangeVals.max}
            list='tickmarks'
          />
          <datalist id='tickmarks'>
            {
              range(rangeVals.min, rangeVals.max, rangeVals.step)
                .map(val => <option>{val}</option>)
            }
          </datalist>
          <ModeInputHelperText
            text={this.props.mode.impactFactorText}
            slider
          />
        </Col>
        <Col md={4}>
          <FormControl
            type='number'
            min={undefined}
            max={undefined}
            step={rangeVals.step}
            value={this.props.mode.impactFactor}
            onChange={this.onChange}
            disabled={this.props.mode.selected === false}
          />
          <ModeInputHelperText
            tooltip={this.props.mode.impactFactorTooltip}
            slider
          />
        </Col>
      </Row>
    );
  }
}

ImpactFactor.propTypes = {
  mode: PropTypes.object,
  updateImpactFactor: PropTypes.func,
};
